import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6wib61r9: FaireBrandEntity = {
  token: "b_6wib61r9",
  type: "brand",
  name: "UNREAL",
  avatarUrl:
    "https://cdn.faire.com/fastly/c630695a23698f7914948604247715e71ddc8da5f0afadbd238cc82dfc2acd32.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b37158c1c5dccce1c487605873af2067a23bdaa641f00c28a8ebdc2edffda347.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c630695a23698f7914948604247715e71ddc8da5f0afadbd238cc82dfc2acd32.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b37158c1c5dccce1c487605873af2067a23bdaa641f00c28a8ebdc2edffda347.png",
  location: "Boston, MA, USA",
  minimumOrderDollars: 83,
  rating: 4.8,
  reviewCount: 81,
  isInsider: true,
  description:
    "As kids, our parents really didn't want us eating our favorite chocolates. The snacks we loved most were filled with artificial ingredients, chemical dyes, excess sugar, and a whole bunch of other things that we couldn't even pronounce.\n\nSo we asked the simple question, \"why do the foods we love most have to be so bad for us?\" and set out to create chocolate snacks that we could actually eat and feel good about. After thousands of recipes, we finally cracked the code! We reinvented our favorites using only real, simple ingredients and with way less sugar. For real.\n\nAnd the taste is UNREAL!\n\n- Kris and Nicky (Founders of UNREAL)",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.746Z",
    importedBy: "entity-db-cli",
  },
};
